<template>
  <a class="callbtn" :href="`tel:${phone}`" @click="onClick">
    <base-icon name="phone" />
    <span><slot>تماس با پشتیبانی</slot></span>
  </a>
</template>

<script>
import BaseIcon from "./BaseIcon.vue";
import { SUPPORT_PHONE } from "@/constants";
import { isDesktop } from "@/utils/device";

/**
 * The support call-to-action.
 *
 * On a phone the `tel:` link hands off to the dialer, which is exactly right. On a
 * desktop it hands off to nothing (or an unwanted default handler), so there we cancel
 * the navigation and emit `reveal` — the parent opens a sheet showing the number with a
 * copy button, since you cannot tap a number on a monitor.
 */
export default {
  name: "SupportLink",
  components: { BaseIcon },

  props: {
    phone: { type: String, default: SUPPORT_PHONE },
  },

  methods: {
    onClick(event) {
      if (!isDesktop()) return; // phone: let the tel: link dial
      event.preventDefault();
      this.$emit("reveal");
    },
  },
};
</script>

<style scoped>
.callbtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  text-decoration: none;
  min-height: 46px;
  padding: 0 16px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--card);
  color: var(--foreground);
  font-family: inherit;
  font-weight: 700;
  font-size: 14.5px;
  -webkit-tap-highlight-color: transparent;
}

.callbtn:active {
  transform: scale(0.99);
}

.callbtn >>> svg {
  width: 17px;
  height: 17px;
  color: var(--primary);
}
</style>
